<template>
    <el-dialog :visible.sync="showTag" width="80%">
        <table width="100%" class="scheme">
            <tr>
                <!--<th>科室</th>-->
                <!--<th>上下午</th>-->
                <th colspan="2">
                    <div class="flex aic jcc">
                        <img :src="doc.docAvatar"/>
                        <div class="ml5">
                            {{doc.docName + ' / ' + '医生'}}<br>
                            相关排班
                        </div>
                    </div>
                </th>
                <th v-for="w in week" :key="w.value">
                    <p>{{w.date}}</p>
                    <p>{{w.week}}</p>
                </th>
            </tr>
            <tr v-if="list.length===0">
                <td colspan="9" align="center" class="nodata">暂无排班</td>
            </tr>
            <tr v-for="ks in list">
                <td align="center" v-if="ks.rowspan" :rowspan="ks.rowspan">{{ks.ksmc}}</td>
                <td align="center">{{ks.sign}}</td>
                <td v-for="sch in ks.schemes" align="center">
                    <p v-if="sch.schemes.length">
                        <span class="pointer color_main" @click="handler(sch.schemes[0])">预约</span>
                    </p>
                </td>
            </tr>
        </table>
    </el-dialog>
</template>
<style scoped lang="scss">
    @import "../../styles/var";

    .scheme {
        border-collapse: collapse;

        td, th {
            border: 1px solid $bgColor;
            padding: 5px 0px;
            font-size: 12px;
        }

        th {
            img{
                width:48px;
                height:48px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
            }
            //width: (100%/9);
            //background-color: rgb(250, 250, 250);
        }

        td {
            padding: 10px 0;
        }

        .nodata {
            padding: 10px 0px;
        }
    }
</style>
<script>
  import {bookService} from "../../lib/service/book";
  import {systemService} from "../../lib/service/system";
  import {isEmpty, timeFormat} from "../../lib/utils";

  export default {
    name: "referral-scheme-dialog",
    data() {
      return {
        title: '',
        info: {},
        week: [],
        list: [],
        showTag: false
      }
    },
    computed: {
      doc() {
        return this.info.doc || {};
      }
    },
    created() {
      this.getWeek();
    },
    methods: {
      getWeek() {
        const d = Date.now();
        let week = [];
        for (let i = 0; i < 7; i++) {
          let delta = d + (i + 1) * 24 * 3600 * 1000;
          week.push({
            week: '星期' + timeFormat(delta, '%W'),
            value: timeFormat(delta, '%Y%m%d'),
            date: timeFormat(delta, '%m-%d')
          })
        }
        this.week = week;
      },
      async show(data) {
        this.info = await systemService.docCard(data.docId);
        const {doc} = this.info;
        if (isEmpty(doc.bookDocId) || isEmpty(doc.bookHosId)) {
          this.list = [];
        } else {
          const {deptSchemeList=[]} = await bookService.yspbinfo({
            docId: doc.bookDocId,
            hosId: doc.bookHosId
          });
          if(deptSchemeList.length == 0){
              this.$message.error('没有查到该医生的排班信息。');
              return
          }
          this.list = this.formatList(deptSchemeList);
        }
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      },
      handler(data) {
        this.$emit('scheme-change', '选择号源', data);
        this.hide();
      },
      formatList(list) {
        const getSchemes = (ampm, list) => {
          return [...this.week].map(r => {
            r.schemes = list.filter(rr => rr.ampm === ampm && rr.schdate === r.value);
            return {...r};
          });
        };
        let ret = [];
        [...list].forEach(r => {
          let schemeList = r.schemeList;
          ret = ret.concat([
            {...r, sign: '上午', rowspan: 2, schemes: getSchemes('1', schemeList)},
            {...r, sign: '下午', schemes: getSchemes('2', schemeList)}
          ]);
        });
        return ret;
      }
    },
  }
</script>

